module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0002 2-dfd4396a5fb38069c744dc2737d97b6c.png";